import { toast } from "react-toastify";

//handle error and show toast
export function handleError(message: string) {
  toast.error(message, {
    position: toast.POSITION.BOTTOM_LEFT,
  })
}
